<div
  *ngIf="paginationType === 'base' && config"
  class="row"
>
  <div class="col-xl-6 d-flex justify-content-start align-items-center">
    <small *ngIf="!mini && !isListagemTickets()" (click)="getAllregisters()">{{
      "MOSTRANDO_PAGINACAO"
        | translate : { from: config.from, to: config.to, total: config.total }
    }}</small>
    <small *ngIf="!mini && isListagemTickets()" class="ticket-pagination-counter">
      {{ "MOSTRANDO_PAGINACAO_PREFIXO" | translate : { from: config.from, to: config.to } }}
      <button
        type="button"
        class="ticket-pagination-total"
        [ngClass]="{ 'ticket-pagination-total--clickable': isTotalConsultavel() }"
        [disabled]="!isTotalConsultavel()"
        [attr.title]="isTotalConsultavel() ? ('CONFERIR_TOTAL_TICKETS' | translate) : null"
        (click)="getAllregisters()"
      >
        {{ getTotalExibido() }}
      </button>
      {{ "MOSTRANDO_PAGINACAO_SUFIXO" | translate }}
    </small>
  </div>
  <div class="col-xl-6 d-flex justify-content-end align-items-center">
    <nav
      aria-label="Page navigation example"
      [ngClass]="{ 'pagination-mini': mini && mini === true }"
    >
      <ul
        class="pagination"
        style="height: 54px; margin-bottom: 0; align-items: center"
      >
        <li class="page-item" *ngIf="!dados_gerais && (config?.last_page && config?.last_page > 2 && paginaAtual > 2)">
          <a
            class="page-link"
            style="z-index: 0 !important"
            href="javascript:void(0)"
            (click)="setPage('first')"
          >
            <i class="fas fa-angle-double-left"></i>
          </a>
        </li>
        <li class="page-item" *ngIf="!dados_gerais && (paginaAtual > 1)">
          <a
            class="page-link"
            style="z-index: 0 !important"
            href="javascript:void(0)"
            aria-label="Previous"
            (click)="setPage('previous')"
          >
            <i class="fa fa-angle-left"></i>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li
          *ngFor="let pagina of paginasVisiveis"
          class="page-item"
          [ngClass]="{ active: pagina === paginaAtual }"
        >
          <a
            class="page-link"
            style="z-index: 0 !important"
            href="javascript:void(0)"
            (click)="setPage(pagina)"
            >{{ pagina }}</a
          >
        </li>
        <li class="page-item" *ngIf="!dados_gerais && (paginaAtual < config?.last_page)">
          <a
            class="page-link"
            style="z-index: 0 !important"
            href="javascript:void(0)"
            aria-label="Next"
            (click)="setPage('next')"
          >
            <i class="fa fa-angle-right"></i>
            <span class="sr-only">Next</span>
          </a>
        </li>
        <li class="page-item" *ngIf="!dados_gerais && (config?.last_page && config?.last_page > 2 && verificaAtalhoUltima())">
          <a
            class="page-link"
            style="z-index: 0 !important"
            href="javascript:void(0)"
            (click)="setPage('last')"
          >
            <i class="fas fa-angle-double-right"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>

<div *ngIf="paginationType === 'syncfusion' && config">
  <div class="e-pagertemplate d-flex justify-content-between">
    <div id="totalPages" class="e-pagertemplatemessage col-xl-6 d-flex align-items-center">
      <small class="e-pagenomsg" *ngIf="(!mini || mini === false) && !isListagemTickets()">{{
        "MOSTRANDO_PAGINACAO"
          | translate
            : { from: config.from, to: config.to, total: config.total }
      }}</small>
      <small *ngIf="(!mini || mini === false) && isListagemTickets()" class="ticket-pagination-counter">
        {{ "MOSTRANDO_PAGINACAO_PREFIXO" | translate : { from: config.from, to: config.to } }}
        <button
          type="button"
          class="ticket-pagination-total"
          [ngClass]="{ 'ticket-pagination-total--clickable': isTotalConsultavel() }"
          [disabled]="!isTotalConsultavel()"
          [attr.title]="isTotalConsultavel() ? ('CONFERIR_TOTAL_TICKETS' | translate) : null"
          (click)="getAllregisters()"
        >
          {{ getTotalExibido() }}
        </button>
        {{ "MOSTRANDO_PAGINACAO_SUFIXO" | translate }}
      </small>
    </div>
    <div class="control-section col-xl-6 d-flex justify-content-end">
      <nav
        aria-label="Page navigation example"
        [ngClass]="{ 'pagination-mini': mini && mini === true }"
      >
        <ul
          class="pagination"
          style="height: 54px; margin-bottom: 0; align-items: center"
        >
          <li class="page-item" *ngIf="!dados_gerais">
            <a
              class="page-link"
              style="z-index: 0 !important"
              href="javascript:void(0)"
              (click)="setPage('first')"
            >
              <i class="fas fa-angle-double-left"></i>
            </a>
          </li>
          <li class="page-item" *ngIf="!dados_gerais">
            <a
              class="page-link"
              style="z-index: 0 !important"
              href="javascript:void(0)"
              aria-label="Previous"
              (click)="setPage('previous')"
            >
              <i class="fa fa-angle-left"></i>
              <span class="sr-only">Previous</span>
            </a>
          </li>
          <li
            *ngFor="let pagina of paginasVisiveis"
            class="page-item"
            [ngClass]="{ active: pagina === paginaAtual }"
          >
            <a
              class="page-link"
              style="z-index: 0 !important"
              href="javascript:void(0)"
              (click)="setPage(pagina)"
              >{{ pagina }}</a
            >
          </li>
          <li class="page-item" *ngIf="!dados_gerais">
            <a
              class="page-link"
              style="z-index: 0 !important"
              href="javascript:void(0)"
              aria-label="Next"
              (click)="setPage('next')"
            >
              <i class="fa fa-angle-right"></i>
              <span class="sr-only">Next</span>
            </a>
          </li>
          <li class="page-item" *ngIf="!dados_gerais">
            <a
              class="page-link"
              style="z-index: 0 !important"
              href="javascript:void(0)"
              (click)="setPage('last')"
            >
              <i class="fas fa-angle-double-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
